/* ==========================================================================
   Meat.Kitchen — product page behaviour
   - Gallery: swipe/scroll-snap track, thumbnails, dots, arrow keys.
   - Sticky "Add to menu" bar once the hero menu card scrolls away;
     hidden again near the closing call to action and the footer.
   Port target: assets/mk-product.js (loaded by sections/mk-product.liquid)
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initGallery(root) {
    if (root.__mkGallery) return;
    root.__mkGallery = true;
    var track = root.querySelector('[data-mk-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-mk-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mk-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.mk-pdp-dots i'));
    var current = 0;
    var frame = 0;
    var steering = 0; /* while a thumbnail-driven scroll runs, ignore intermediate positions */

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-mk-thumb'), 10) === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      steering = Date.now() + 700;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-mk-thumb'), 10) || 0); });
    });
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        if (Date.now() < steering) return;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    /* Keep the active slide aligned when the viewport changes size. */
    window.addEventListener('resize', function () { track.scrollTo({ left: current * track.clientWidth, behavior: 'instant' }); });
    track.addEventListener('scrollend', function () { steering = 0; });
    setActive(0);
  }

  function initBar(pdp) {
    var bar = pdp.querySelector('[data-mk-pdp-bar]');
    var anchor = pdp.querySelector('[data-mk-pdp-menu]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(bar.querySelectorAll('a, button'));
    var pastHero = false;
    var nearEnd = false;

    function apply() {
      var show = pastHero && !nearEnd;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      links.forEach(function (el) { el.setAttribute('tabindex', show ? '0' : '-1'); });
      document.body.classList.toggle('mk-pdp-bar-on', show);
    }
    /* Measured on scroll (not an IntersectionObserver): jump links and fast flicks can skip straight past the
       card on phones, where it starts below the fold, and an observer never fires for that. */
    var ticking = false;
    function measure() {
      ticking = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      if (past !== pastHero) { pastHero = past; apply(); }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(measure); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    apply();
    measure();

    var ends = Array.prototype.slice.call(document.querySelectorAll('.mk-pdp .mk-cta-wrap, .mk-pdp-dinner__actions, footer, .footer'));
    var visible = new Set();
    var endObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      nearEnd = visible.size > 0;
      apply();
    }, { threshold: 0.15 });
    ends.forEach(function (el) { endObserver.observe(el); });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mk-gallery]'), initGallery);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mk-pdp]'), function (pdp) {
      if (pdp.__mkBar) return;
      pdp.__mkBar = true;
      initBar(pdp);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
